import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'arabicInEnglishError'
})
export class ArabicInEnglishError implements PipeTransform {

  transform(control: any, ...args: any[]): string {
    return 'This field accepts english text only.';
  }

}
